
export class cabecalho {

    public header: string;
    public field: string;
  }


// WEBPACK FOOTER //
// ./src/app/entity/cabecalho-prestacao-conta.model.ts